import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import { enqueueSnackbar } from "notistack";
import { hostNameBack } from '../../utils/constants';

function Terms() {
    const [terms, setTerms] = useState("");

    useEffect(() => {
        axios.get(`${hostNameBack}/api/v1/settings/admin/terms`)
            .then(res => {
                if (res.data.success) {
                    setTerms(res.data?.terms || "");
                }
            })
            // .catch(e => {
            //     enqueueSnackbar(e?.reponse?.data?.error || "Something went wrong!", { variant: "error" });
            // });
    }, []);

    return (
        <div className='termsDiv'>
            <div className="termsContent">
                <img src="./assets/images/terms.svg" alt="Terms and Conditions" className='termsBanner selectDisable' draggable={false} />
                <div className="termsTextDiv">
                    <div dangerouslySetInnerHTML={{ __html: terms }} />
                </div>
            </div>
        </div>
    );
}

export default Terms;
